import { Program } from '@customTypes/Entities';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@store';

export type ProgramsState = {
  selected: Array<number>;
  query: string;
  date: string | null;
  names: { [key: number]: string };
};

const initialDate = new Date();
initialDate.setDate(initialDate.getDate() - 7);
initialDate.setHours(0, 0, 0, 0);

const initialState: ProgramsState = {
  selected: [],
  query: '',
  date: initialDate.toISOString(),
  names: {},
};

export const programsSlice = createSlice({
  name: 'programs',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    check: (state, action: PayloadAction<Program>) => {
      state.selected = state.selected.concat(action.payload.id);
      state.names[action.payload.id] = action.payload.name;
    },
    uncheck: (state, action: PayloadAction<number>) => {
      state.selected = state.selected.filter((s) => s !== action.payload);
      delete state.names[action.payload];
    },
    checkAll: (state, action: PayloadAction<Program[]>) => {
      state.selected = [];
      state.selected = state.selected.concat(action.payload.map((prog) => prog.id));
      action.payload.forEach((prog) => (state.names[prog.id] = prog.name));
    },
    uncheckAll: (state) => {
      state.selected = [];
      state.names = {};
    },

    setQuery: (state, action: PayloadAction<string>) => {
      state.query = action.payload;
    },
    setDate: (state, action: PayloadAction<string | null>) => {
      state.date = action.payload;
    },
  },
});

export const { check, uncheck, checkAll, uncheckAll, setDate, setQuery } = programsSlice.actions;

export const getSelectedPrograms = (state: RootState) => state.programs.selected;

export const getSelectedNamedPrograms = (state: RootState) =>
  Object.entries(state.programs.names).map(([k, v]) => ({
    id: Number(k),
    name: v,
  }));

export const getProgramsQuery = (state: RootState) => state.programs.query;

export const getProgramsDate = (state: RootState) => state.programs.date;

export default programsSlice.reducer;
